import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f10c7a7c&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f10c7a7c')) {
      api.createRecord('f10c7a7c', component.options)
    } else {
      api.reload('f10c7a7c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f10c7a7c&", function () {
      api.rerender('f10c7a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/Webhooks/Index.vue"
export default component.exports